module.exports = __webpack_public_path__ + "img/iphone8screenshot4.73eac495.png";